import { Reveal } from "@components/ui";
import tickCircle from "@assets/images/vuesax-linear-tick-circle.svg";

const checklistItems = [
  { text: "Daily leak check by kitchen supervisor", frequency: "Daily" },
  { text: "Weekly cleaning of hoods & ducts", frequency: "Weekly" },
  {
    text: "Quarterly deep cleaning of extraction system",
    frequency: "Quarterly",
  },
  { text: "Trained staff for emergency shutoff", frequency: "Staff" },
  {
    text: "Gas lines must remain uncovered and accessible",
    frequency: "Always",
  },
  {
    text: "No storage of chemicals under gas cookers",
    frequency: "Always",
  },
  {
    text: (
      <>
        Install <strong className="text-[#122d63]">gas solenoid valve</strong>{" "}
        integrated with fire alarm panel
      </>
    ),
    frequency: "Mandatory",
  },
];

export function CommercialSafetySection() {
  return (
    <section className="w-full bg-white overflow-hidden px-5 md:px-10 lg:px-[180px] py-12 md:py-16 lg:py-[100px]">
      <div className="w-full max-w-[1368px] mx-auto flex flex-col gap-10 md:gap-14 lg:gap-16">
        {/* Header Row */}
        <Reveal direction="up">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 md:gap-8">
            <div className="flex flex-col items-start gap-3 md:gap-4 max-w-[700px]">
              <span className="inline-block px-4 py-1.5 rounded-full bg-[#f24d2b]/10 text-[#f24d2b] text-[13px] md:text-[15px] font-semibold tracking-[-0.02em] uppercase">
                Commercial & F&B
              </span>
              <h2 className="text-[28px] md:text-[44px] lg:text-[54px] font-semibold tracking-[-0.04em] text-[#122d63] leading-[1.1]">
                For Commercial & F&B Clients
              </h2>
              <p className="text-[14px] md:text-[18px] lg:text-[22px] tracking-[-0.04em] text-[#62636c] leading-[1.5]">
                Restaurants, cafes, and hotels must follow enhanced safety rules
                to maintain compliance and protect their premises.
              </p>
            </div>

            {/* AMC highlight card */}
            <div className="lg:shrink-0 rounded-[16px] bg-gradient-to-br from-[#122d63] to-[#1a3f7a] p-5 md:p-6 max-w-[360px]">
              <p className="text-[14px] md:text-[16px] text-white/80 leading-[1.5]">
                <span className="text-white font-semibold">GASIS offers AMC contracts</span>{" "}
                including commercial safety audits tailored for F&B operations.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Checklist Grid */}
        <Reveal direction="up">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
            {checklistItems.map((item, index) => (
              <div
                key={index}
                className="group flex items-start gap-4 p-4 md:p-5 rounded-[16px] bg-[#f8f9fb] hover:bg-white hover:shadow-[0_2px_16px_rgba(0,0,0,0.08)] transition-all duration-300 border border-transparent hover:border-[#e8e9ed]"
              >
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-[#e8f5e6] flex items-center justify-center shrink-0 group-hover:bg-[#269d0e]/15 transition-colors">
                  <img
                    src={tickCircle}
                    alt=""
                    className="w-5 h-5 md:w-6 md:h-6"
                  />
                </div>
                <div className="flex-1 flex flex-col gap-1">
                  <p className="text-[14px] md:text-[17px] lg:text-[18px] tracking-[-0.03em] text-[#1e1f24] leading-[1.5]">
                    {item.text}
                  </p>
                  <span className="text-[11px] md:text-[12px] font-semibold uppercase tracking-[0.05em] text-[#62636c]/60">
                    {item.frequency}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
